import { AxiosError } from 'axios';
import { ApiError } from '../types';
import { translate } from '../i18n/translations';
import { useLocaleStore } from '../stores/localeStore';

const localizeServerMessage = (message: string, fallback: string): string => {
  const locale = useLocaleStore.getState().locale;
  if (locale === 'en') return message;
  const localized = translate(message, locale);
  return localized === message ? translate(fallback, locale) : localized;
};

export function getErrorMessage(error: unknown, fallback: string): string {
  const responseData = (error as AxiosError<ApiError>).response?.data;
  const message = responseData?.message;

  if (Array.isArray(message)) {
    return message.map((item) => localizeServerMessage(item, fallback)).join(', ');
  }

  if (typeof message === 'string' && message.trim()) {
    return localizeServerMessage(message, fallback);
  }

  if (error instanceof Error && error.message) {
    return localizeServerMessage(error.message, fallback);
  }

  return translate(fallback, useLocaleStore.getState().locale);
}
